import { AxiosError } from 'axios';

/*
 * Parses an exception we expect to be an Axios HTTP request
 * exception and returns a user-friendly message to display on the
 * tool's UI
 */
export const parseAxiosErrorMessage = (e: any): string => {
  if (e === null || e === undefined) {
    return 'Unknown error';
  }

  if (e instanceof AxiosError) {
    // Out of AI credits (crud/ai_credits.py): the server's text already says
    // when the next credit comes back — show it as-is.
    if (e.response?.status === 429 && typeof e.response?.data === 'string') {
      return e.response.data;
    }
    let { message } = e;
    if (typeof e.response?.data === 'string') {
      message += ` - ${e.response.data}`;
    }
    return message;
  }
  return e.toString();
};

export const isIgdbServiceUnavailableError = (e: any): boolean => e instanceof AxiosError && e.response?.status === 501;

export const getIgdbServiceUnavailableMessage = (): string => 'Game import from IGDB is currently unavailable. Please contact an administrator to configure IGDB credentials.';
